import { MapProviderModel } from '@cas/types/settings';
import { useAppSelector } from '@casops/store/hooks';

export const useMapProvider = (): MapProviderModel => {
  return useAppSelector(state => state.settings.map);
};

export default useMapProvider;
